import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialog({ openDialog, title, msg, showDialog, confirmCase }) {

  const handleConfirm = () => {
    showDialog(false);
    confirmCase();
  };

  const handleClose = () => {
    showDialog(false);
  };

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle className="reconect-text">{title}</DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {msg}
        </DialogContentText>
      </DialogContent>

      <div className='rows m-2'>
        <Button color='error' style={{ fontWeight: 'bolder', float: 'left' }} onClick={() => showDialog(false)}>Cancelar</Button>
        <Button color='success' style={{ fontWeight: 'bolder', float: 'right' }} onClick={handleConfirm}>Confirmar</Button>
      </div>
    </Dialog>
  );
}
